<template>
   <iframe v-if="myHawkLoginToken !== ''" :src="iframeUrl"
    frameborder="0"
    sandbox="allow-same-origin allow-scripts allow-forms allow-top-navigation"
    style="width:100%;height:100%;"
    ></iframe> 
    <b-overlay v-else show class="h-100" />
</template>
<script>
import config from '@/config';
import tmsApi from './../api/tmsApi';

export default {
  name: 'hawk-iframe',
  data: () => ({
    myHawkLoginToken: '',
  }),
  props: {
    path: {
      type: String,
      required: false,
      default: 'p/map',
    },
  },
  created() {
    const query = '{ loginToken: get_hawk_token }';
    tmsApi.build(this.token)(query).then(({ data }) => {
      this.myHawkLoginToken = data.loginToken || '';
    });
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
    hawkLoginToken() {
      return encodeURIComponent(this.myHawkLoginToken);
    },
    iframeUrl() {
      return `${config.hawkUrl}index.php/${this.path}?login_token=${this.hawkLoginToken}&iframe_mode=1&custom_css=tms`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/HawkIframe.vue